import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "doer-emoji-modal-view__header" }
const _hoisted_2 = { class: "doer-emoji-modal-view__emoji-dialog-form" }
const _hoisted_3 = { class: "doer-emoji-modal-view__navigation" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Выйти из аккаунта ")
const _hoisted_5 = { class: "ion-padding-horizontal ion-padding-bottom" }
const _hoisted_6 = ["href"]

import { onMounted, ref } from 'vue';
import { modalController } from '@ionic/vue';
import { useAlert } from '@/composables/alert';
import { useDoerMood } from '@/composables/doer';
import { useStore } from '@/composables/useApp';
import { useNavManager } from '@/composables/useNavManager';
import MoodChoice from '@/components/doer/MoodChoice.vue';
import { computed } from '@vue/reactivity';
import { useMetrica } from '@/composables/useMetrica';
import config from '@/config';


export default /*#__PURE__*/_defineComponent({
  emits: ["logout"],
  setup(__props, { emit }: { emit: ({
  (e: 'logout'): void;
}), expose: any, slots: any, attrs: any }) {



const store = useStore();
const { createAlertConfirm } = useAlert();
const navManager = useNavManager();
const { emitEvent } = useMetrica();
const contractOfferLink = config.privacyPolicyLink;

/** @private */
async function logout() {
  try {
    await store.user.logout();
  } finally {
    navManager.navigate({
      routerDirection: 'root',
      routerLink: { name: 'login' },
    });

    emit('logout');
    modalController.dismiss();
  }
}

const confirmLogout = createAlertConfirm({
  header: 'Подтверждение',
  message: 'Вы действительно хотите выйти',
  confirmBtnText: 'Выйти',

  async confirm() {
    emitEvent('user/logout');
    await logout();
  }
});

//#region Mood
const doerMood = ref(0);

const {
  submitMood,
  loadingMood,
  loadingUpdateMood,
  loadMood,
  hasMood,
  isSubmitMood,
  formSubmittedFlag,
  mood,
  // isStartHasMood,
  moodExtendInfo,
  isForsedMood,
} = useDoerMood();

onMounted(async () => {
  await loadMood();
  doerMood.value = mood.value;
});

const submitMoodBtnDisabled = computed(() => {
  return !isSubmitMood.value
    || loadingUpdateMood.value
    || loadingMood.value
    || !doerMood.value
    // || formSubmittedFlag.value // Кнопка "Принято!" - должна работать, т.к. для нее есть специальная логика
  ;
});

const submitMoodBtnText = computed(() => {
  if (loadingUpdateMood.value) {
    return 'Отправляю...';
  }

  if (formSubmittedFlag.value) {
    return 'Принято!';
  }

  return 'Поставить оценку';
});

const titleMood = computed(() => {
  if (formSubmittedFlag.value) {
    return 'Спасибо за вашу оценку';
  }

  // NOTE: Последняя оценка mood всегда возвращается,
  // всегда нужно отображать прошлую оценку.
  // if (isStartHasMood.value) {
  //   return 'Вы уже поставили оценку';
  // }
  // if (!isSubmitMood.value) {
  //   return 'День еще не закончился';
  // }

  if (!isSubmitMood.value) {
    return 'Вы уже поставили оценку';
  }

  return 'Оцените работу вашего предприятия';
});

function submitForm() {
  if (formSubmittedFlag.value) {
    return modalController.dismiss();
  }

  submitMood(doerMood.value);
  emitEvent('user/mood/submit', { value: doerMood.value });
}
//#endregion

function dismiss() {
  if (!isForsedMood.value) {
    modalController.dismiss();
  }
}

return (_ctx: any,_cache: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "doer-emoji-modal-view__backgroup",
      onClick: dismiss
    }),
    _createElementVNode("div", _hoisted_1, [
      (!_unref(isForsedMood))
        ? (_openBlock(), _createBlock(_component_ion_button, {
            key: 0,
            class: "d-close-button",
            color: "light",
            fill: "clear",
            onClick: _withModifiers(dismiss, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, { name: "core-close-backgroup" })
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass({
    'doer-emoji-modal-view__emoji-dialog': true,
    'doer-emoji-modal-view__emoji-dialog--loading': _unref(loadingMood),
  })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h4", null, _toDisplayString(_unref(titleMood)), 1),
        (_unref(hasMood) && _unref(moodExtendInfo) && _unref(formSubmittedFlag))
          ? (_openBlock(), _createBlock(_component_ion_icon, {
              key: 0,
              src: _unref(moodExtendInfo).iconSrc,
              class: "doer-emoji-modal-view__emoji-current",
              style: _normalizeStyle({ color: _unref(moodExtendInfo).color })
            }, null, 8, ["src", "style"]))
          : (_openBlock(), _createBlock(MoodChoice, {
              key: 1,
              lock: !_unref(isSubmitMood),
              modelValue: doerMood.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((doerMood).value = $event)),
              class: "doer-emoji-modal-view__mood"
            }, null, 8, ["lock", "modelValue"]))
      ]),
      _createVNode(_component_ion_button, {
        onClick: submitForm,
        expand: "block",
        class: _normalizeClass({
        'doer-emoji-modal-view__emoji-dialog-button': true,
        'doer-emoji-modal-view__emoji-dialog-button--completed': _unref(formSubmittedFlag),
      }),
        disabled: _unref(submitMoodBtnDisabled)
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(submitMoodBtnText)), 1)
        ]),
        _: 1
      }, 8, ["class", "disabled"])
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_ion_button, {
        fill: "clear",
        color: "transparent",
        class: "ion-no-padding",
        onClick: _unref(confirmLogout)
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", {
          href: _unref(contractOfferLink),
          target: "_blank",
          class: "cd-contract-offer-link"
        }, " Посмотреть политику ", 8, _hoisted_6)
      ])
    ])
  ], 64))
}
}

})